var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWave = function SvgWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 320"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d27979",
    d: "m0 288 48-16c48-16 144-48 240-74.7 96-26.3 192-48.3 288-32 96 15.7 192 69.7 288 85.4 96 16.3 192-5.7 288 0 96 5.3 192 37.3 240 53.3l48 16H0Z"
  })));
};

export { SvgWave as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTQ0MCAzMjAiPjxwYXRoIGZpbGw9IiNkMjc5NzkiIGZpbGwtb3BhY2l0eT0iMSIgZD0iTTAsMjg4TDQ4LDI3MkM5NiwyNTYsMTkyLDIyNCwyODgsMTk3LjNDMzg0LDE3MSw0ODAsMTQ5LDU3NiwxNjUuM0M2NzIsMTgxLDc2OCwyMzUsODY0LDI1MC43Qzk2MCwyNjcsMTA1NiwyNDUsMTE1MiwyNTAuN0MxMjQ4LDI1NiwxMzQ0LDI4OCwxMzkyLDMwNEwxNDQwLDMyMEwxNDQwLDMyMEwxMzkyLDMyMEMxMzQ0LDMyMCwxMjQ4LDMyMCwxMTUyLDMyMEMxMDU2LDMyMCw5NjAsMzIwLDg2NCwzMjBDNzY4LDMyMCw2NzIsMzIwLDU3NiwzMjBDNDgwLDMyMCwzODQsMzIwLDI4OCwzMjBDMTkyLDMyMCw5NiwzMjAsNDgsMzIwTDAsMzIwWiI+PC9wYXRoPjwvc3ZnPgo=";